import { Input, Select } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { getExpectNumber } from '../../../../../common'
import { SearchDrawerComponent } from '../../../../../components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'
import { setCardFilter } from '../../../../../stores/actions'

const StyledRow = styled.div`
  margin-bottom: 10px;
  display: flex;
`

const StyledLabel = styled.span`
  border: 1px solid #d9d9d9;
  border-right: none;
  padding: 3px 10px;
  background-color: #fafafa;
  display: inline-flex;
`

export const SearchCardDrawerComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { cardFilter } = useSelector((state: RootState) => state.card)
  const { language } = useSelector((state: RootState) => state.language)
  const [filter, setFilter] = React.useState(cardFilter)

  const body = (
    <>
      <StyledRow>
        <Input
          allowClear
          placeholder={translate('common.customer', language)}
          addonBefore={translate('common.customer', language)}
          value={filter.customerName}
          onChange={(e) =>
            setFilter({
              ...filter,
              customerName: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow style={{ flexWrap: 'wrap' }}>
        <Input
          placeholder={translate('card.availableBalance.from', language)}
          addonBefore={translate('card.availableBalance.from', language)}
          value={filter.availableBalanceFrom}
          type="number"
          style={{ marginBottom: '10px' }}
          allowClear
          min={1}
          onChange={(e: any) =>
            setFilter({
              ...filter,
              availableBalanceFrom: e.target.value,
            })
          }
        />
        <Input
          placeholder={translate('card.availableBalance.to', language)}
          addonBefore={translate('card.availableBalance.to', language)}
          value={filter.availableBalanceTo}
          type="number"
          allowClear
          min={1}
          onChange={(e: any) =>
            setFilter({
              ...filter,
              availableBalanceTo: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow style={{ flexWrap: 'wrap' }}>
        <Input
          placeholder={translate('common.accountsPayable.from', language)}
          addonBefore={translate('common.accountsPayable.from', language)}
          value={filter.accountsPayableFrom}
          type="number"
          style={{ marginBottom: '10px' }}
          allowClear
          min={1}
          onChange={(e: any) =>
            setFilter({
              ...filter,
              accountsPayableFrom: e.target.value,
            })
          }
        />
        <Input
          placeholder={translate('common.accountsPayable.to', language)}
          addonBefore={translate('common.accountsPayable.to', language)}
          value={filter.accountsPayableTo}
          type="number"
          allowClear
          min={1}
          onChange={(e: any) =>
            setFilter({
              ...filter,
              accountsPayableTo: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <StyledLabel>{translate('common.status', language)}</StyledLabel>
        <Select
          mode="multiple"
          maxTagCount="responsive"
          placeholder={translate('common.status', language)}
          style={{ width: '100%' }}
          value={filter.statuses}
          onChange={(e) =>
            setFilter({
              ...filter,
              statuses: e,
            })
          }
        >
          {['activated', 'deactivated'].map((item) => (
            <Select.Option value={item} key={item}>
              {translate(`card.status.${item}`, language)}
            </Select.Option>
          ))}
        </Select>
      </StyledRow>
    </>
  )

  return (
    <SearchDrawerComponent
      body={body}
      onSearch={() =>
        dispatch(
          setCardFilter({
            ...filter,
            pageIndex: 1,
            accountsPayableFrom: getExpectNumber(
              true,
              filter.accountsPayableFrom,
              filter.accountsPayableTo
            ),
            accountsPayableTo: getExpectNumber(
              false,
              filter.accountsPayableFrom,
              filter.accountsPayableTo
            ),
            availableBalanceFrom: getExpectNumber(
              true,
              filter.availableBalanceFrom,
              filter.availableBalanceTo
            ),
            availableBalanceTo: getExpectNumber(
              false,
              filter.availableBalanceFrom,
              filter.availableBalanceTo
            ),
          })
        )
      }
    />
  )
}
